<template>
  <div v-show="show">
    <v-dialog v-model="model" width="600px">
      <v-container class="pa-1">
        <v-layout row wrap>
          <v-flex xs12>
            <v-card>
              <v-card-title primary-title class="px-2 pt-3 pb-2">
                <div class="IR_M f_16 pl-2 pr-2">{{ title }}</div>
                <v-divider />
                <v-btn class="ma-0" icon @click="close">
                  <v-icon class="pink--text">close</v-icon>
                </v-btn>
              </v-card-title>
              <v-layout wrap justify-center>
                <v-flex xs11>
                  <div>{{ message }}</div>
                </v-flex>
              </v-layout>
              <v-card-actions>
                <v-layout class="pt-3 pb-2 pr-2" row reverse>
                  <v-btn
                    :loading="loading"
                    @click="deleteItem"
                    class="IR pink white--text shadow"
                  >
                    <span>DELETE</span>
                  </v-btn>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-dialog>
  </div>
</template>
<script>
import { store } from "@/store";
export default {
  data() {
    return {
      path: null,
      show: false,
      loading: false,
      title: "Delete Record",
      message: "Are you sure you want to delete selected item?"
    };
  },
  methods: {
    deleteItem() {
      this.loading = true;
      this.axios
        .delete(this.path)
        .then(resp => {
          if (resp.data.success) {
            this.success();
          } else {
            store.commit("showSnackbar", {
              stateType: "error",
              text: resp.data.msg,
              show: true
            });
            this.loading = false;
            this.close();
          }
        })
        .catch(() => (this.loading = false));
    },
    success() {
      this.show = false;
      this.loading = false;
      store.commit("showSnackbar", {
        text: "Records deleted successfully.",
        stateType: "success",
        show: true
      });
    },

    close() {
      this.loading = false;
      this.show = false;
    }
  },
  computed: {
    model: {
      get() {
        return this.show;
      },
      set() {
        this.close();
      }
    }
  }
};
</script>
